<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div v-for="provider in singleprovider" v-bind:key="provider.id">

        <!-- ── Page Header ───────────────────────────────────── -->
        <div class="page-header">
          <div class="container">
            <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
              <div class="header-icon-wrap">
                <i class="fe fe-home" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">{{ provider.agency_name }}</h4>
                <div class="d-flex align-items-center mt-1" style="gap: 8px;">
                  <span v-if="provider.status == true" class="header-status header-status--active">
                    <i class="fe fe-check-circle mr-1"></i> Approved
                  </span>
                  <span v-if="provider.status == false" class="header-status header-status--inactive">
                    <i class="fe fe-clock mr-1"></i> Pending
                  </span>
                  <span v-if="provider.phc_type" class="header-id-badge">{{ provider.phc_type }}</span>
                  <span v-if="provider.phc_general" class="header-id-badge">{{ provider.phc_general }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container mt-n3 pb-5">

          <!-- ── Action Bar ──────────────────────────────────── -->
          <div class="card action-card shadow mb-4">
            <div class="card-body py-3 px-4 d-flex flex-wrap" style="gap: 8px;">
              <button class="btn btn-sm btn-outline-success" @click="acceptProvider(1)" v-if="provider.status == false">
                <i class="fe fe-check-circle mr-1"></i> Approve
              </button>
              <button class="btn btn-sm btn-outline-danger" @click="acceptProvider(0)" v-if="provider.status == true">
                <i class="fe fe-x-circle mr-1"></i> Disapprove
              </button>
              <button class="btn btn-sm btn-outline-danger" @click="deleteUser">
                <i class="fe fe-trash-2 mr-1"></i> Delete
              </button>
              <router-link :to="{ path: '/provider/add-employee/' + provider.id }">
                <button class="btn btn-sm btn-outline-primary">
                  <i class="fe fe-users mr-1"></i> Manage Personnel
                </button>
              </router-link>
              <router-link :to="{ path: '/payout-account', query: { provider_id: provider.id } }">
                <button class="btn btn-sm btn-outline-success">
                  <i class="fe fe-credit-card mr-1"></i> Payout Account
                </button>
              </router-link>
              <router-link :to="{ path: '/edit-provider/' + provider.id }">
                <button class="btn btn-sm btn-outline-info">
                  <i class="fe fe-edit-2 mr-1"></i> Edit Facility
                </button>
              </router-link>
              <button class="btn btn-sm btn-outline-dark" @click="getAIComments"
                data-toggle="modal" data-target="#slideRightModalAll">
                <i class="fe fe-message-circle mr-1"></i> Reviews
              </button>
            </div>
          </div>

          <!-- Specializations (shared medical list; shown when booking appointments / telemedicine) -->
          <SpecializationsCard v-if="provider.id" :user-id="provider.id"
            :editable="!!user && (user.type == 'shis' || user.type == 'employee')" />

          <!-- ── Stats Tiles ─────────────────────────────────── -->
          <div class="row mb-4">
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Total Enrollees</p>
                  <h3 class="mb-0 font-weight-bold">{{ dashboarddata.enrollees | numeral("0,0") }}</h3>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Principal</p>
                  <h3 class="mb-0 font-weight-bold">{{ dashboarddata.principal | numeral("0,0") }}</h3>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Dependents</p>
                  <h3 class="mb-0 font-weight-bold">{{ dashboarddata.dependants | numeral("0,0") }}</h3>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Encounters</p>
                  <h3 class="mb-0 font-weight-bold">{{ dashboarddata.encounters | numeral("0,0") }}</h3>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Claims</p>
                  <router-link :to="{ path: '/all-claims' }">
                    <h3 class="mb-0 font-weight-bold">{{ dashboarddata.claims | numeral("0,0") }}</h3>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Out-going Referrals</p>
                  <h3 class="mb-0 font-weight-bold">{{ dashboarddata.outgoing_referrals | numeral("0,0") }}</h3>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">In-coming Referrals</p>
                  <h3 class="mb-0 font-weight-bold">{{ dashboarddata.incoming_referrals | numeral("0,0") }}</h3>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Employees</p>
                  <h3 class="mb-0 font-weight-bold">{{ dashboarddata.employees | numeral("0,0") }}</h3>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Total Utilization Rate</p>
                  <h3 class="mb-0 font-weight-bold">{{ dashboarddata.encounter_rate_total | numeral("0,0.00") }}%</h3>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Total Referral Rate</p>
                  <h3 class="mb-0 font-weight-bold">{{ dashboarddata.referral_rate_total | numeral("0,0.00") }}%</h3>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Utilization Rate (Current Month)</p>
                  <h3 class="mb-0 font-weight-bold">{{ dashboarddata.encounter_rate_current_month | numeral("0,0.00") }}%</h3>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Referral Rate (Current Month)</p>
                  <h3 class="mb-0 font-weight-bold">{{ dashboarddata.referral_rate_current_month | numeral("0,0.00") }}%</h3>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Total Claim Payment</p>
                  <h3 class="mb-0 font-weight-bold"><i class="mdi mdi-currency-ngn"></i>{{ 0 | numeral("0,0.00") }}</h3>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Total Enrollee Utilization</p>
                  <h3 class="mb-0 font-weight-bold"><i class="mdi mdi-currency-ngn"></i>{{ 0 | numeral("0,0.00") }}</h3>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Reviews</p>
                  <h3 class="mb-0 font-weight-bold">{{ dashboarddata.reviews | numeral("0,0") }}</h3>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-4 col-6 mb-3">
              <div class="card border-0 shadow-sm h-100">
                <div class="card-body py-3 px-3">
                  <p class="text-muted mb-1 text-uppercase" style="font-size:.7rem;letter-spacing:.05em;">Avg. Rating</p>
                  <h3 class="mb-0 font-weight-bold">{{ dashboarddata.average_rating | numeral("0.00") }}</h3>
                </div>
              </div>
            </div>
          </div>
          <!-- ── Facility performance (time-based, ranked against the agency) ── -->
          <FacilityAnalytics v-if="canSeeAnalytics" :facility-id="$route.params.id" :key="'fa-' + $route.params.id" />


          <!-- ── Enrollees Table + Facility Details ──────────── -->
          <div class="row">
            <div class="col-lg-8 col-md-8">
              <div class="card shadow table-card mb-4">
                <div class="px-4 pt-4 pb-2">
                  <h6 class="mb-3 font-weight-bold text-dark">
                    <i class="fe fe-users text-primary mr-2"></i> Facility Enrollees
                    <span class="badge badge-soft-info ml-1" v-if="filteredProviderclients.length">{{ filteredProviderclients.length }}</span>
                  </h6>
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <label class="small font-weight-bold text-secondary">Filter by HMO</label>
                      <select class="form-control form-control-sm" v-model="org_id" @change="getProviderClients">
                        <option value="">All HMOs</option>
                        <option v-for="hmo in tpas" :key="hmo.id" :value="hmo.id">
                          {{ hmo.organization_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-5">
                      <label class="small font-weight-bold text-secondary">Move selected enrollees to</label>
                      <select class="form-control form-control-sm" v-model="targetProviderId">
                        <option value="">Select new provider</option>
                        <option v-for="hcp in providers" :key="hcp.id" :value="hcp.id">
                          {{ hcp.agency_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-3 d-flex align-items-end">
                      <button class="btn btn-sm btn-outline-primary btn-block" @click="moveSelectedEnrollees"
                        :disabled="isMoving || selectedEnrolleeIds.length === 0 || !targetProviderId">
                        {{ isMoving ? "Moving..." : `Move (${selectedEnrolleeIds.length})` }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead class="table-head">
                      <tr>
                        <th class="table-th px-4" style="width:40px;">
                          <input type="checkbox" v-model="selectAllEnrollees" @change="toggleSelectAllEnrollees" />
                        </th>
                        <th class="table-th">Name</th>
                        <th class="table-th">Enrollee ID</th>
                        <th class="table-th">Contact</th>
                        <th class="table-th">HMO</th>
                        <th class="table-th">Program</th>
                        <th class="table-th">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="enrollee in pagedProviderclients" v-bind:key="enrollee.id" class="table-row">
                        <td class="px-4 py-3">
                          <input type="checkbox" :value="enrollee.id" v-model="selectedEnrolleeIds"
                            @change="syncSelectAllState" />
                        </td>
                        <td class="py-3">
                          <router-link :to="{ path: '/client/' + enrollee.id }" class="font-weight-bold" style="font-size:.88rem;">
                            {{ enrollee.firstname }} {{ enrollee.lastname }}
                          </router-link>
                        </td>
                        <td class="py-3">
                          <span class="code-chip">{{ enrollee.id_card_number }}</span>
                        </td>
                        <td class="py-3" style="font-size:.82rem;">{{ enrollee.phone_number }}</td>
                        <td class="py-3" style="font-size:.82rem;">
                          <span v-if="enrollee.usertpa">{{ enrollee.usertpa.organization_name }}</span>
                          <span v-else class="text-muted">N/A</span>
                        </td>
                        <td class="py-3">
                          <span class="rel-chip">{{ enrollee.sector }}</span>
                        </td>
                        <td class="py-3">
                          <router-link :to="{ path: '/client/' + enrollee.id }">
                            <button type="button" class="btn btn-sm btn-outline-primary">
                              <i class="fe fe-eye"></i>
                            </button>
                          </router-link>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="d-flex align-items-center px-4 py-3" v-if="filteredProviderclients.length > pageSize">
                  <small class="text-muted mr-auto">
                    Showing {{ (page - 1) * pageSize + 1 }}–{{ Math.min(page * pageSize, filteredProviderclients.length) }}
                    of {{ filteredProviderclients.length }}
                  </small>
                  <b-pagination v-model="page" :total-rows="filteredProviderclients.length" :per-page="pageSize"
                    size="sm" class="mb-0" />
                </div>
              </div>
            </div>

            <!-- ── Facility Details Sidebar ──────────────────── -->
            <div class="col-lg-4 col-md-4">
              <div class="card shadow table-card mb-4">
                <div class="form-card-header">
                  <div class="section-number"><i class="fe fe-home" style="font-size:12px;"></i></div>
                  <h6 class="mb-0 font-weight-bold text-white">Facility Details</h6>
                </div>
                <ul class="list-unstyled mb-0">
                  <li class="info-row">
                    <i class="fe fe-activity info-icon"></i>
                    <div>
                      <p class="info-label">Status</p>
                      <span v-if="provider.status == true" class="status-badge status-badge--approved">Approved</span>
                      <span v-if="provider.status == false" class="status-badge status-badge--pending">Pending</span>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-users info-icon"></i>
                    <div>
                      <p class="info-label">Beneficiaries Enrolled</p>
                      <p class="info-value">{{ providerclients.length }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-user info-icon"></i>
                    <div>
                      <p class="info-label">Contact Name</p>
                      <p class="info-value">{{ provider.firstname }} {{ provider.lastname }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-mail info-icon"></i>
                    <div>
                      <p class="info-label">Email</p>
                      <p class="info-value">{{ provider.email }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-phone info-icon"></i>
                    <div>
                      <p class="info-label">Phone Number</p>
                      <p class="info-value">{{ provider.phone_number }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-home info-icon"></i>
                    <div>
                      <p class="info-label">Facility Type</p>
                      <p class="info-value">{{ provider.phc_general }}</p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-map-pin info-icon"></i>
                    <div>
                      <p class="info-label">LGA / Ward</p>
                      <p class="info-value">
                        <span v-if="provider.user && provider.user.localgovt">{{ provider.user.localgovt.local_name }} / </span>
                        <span v-if="provider.user && provider.user.ward">{{ provider.user.ward.ward_name }}</span>
                      </p>
                    </div>
                  </li>
                  <li class="info-row">
                    <i class="fe fe-navigation info-icon"></i>
                    <div>
                      <p class="info-label">Address</p>
                      <p class="info-value">{{ provider.address1 }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- ── Reviews Modal ───────────────────────────────── -->
          <div class="modal fade modal-slide-right" id="slideRightModalAll" tabindex="-1"
            role="dialog" aria-labelledby="slideRightModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content" id="printDiv" ref="printNow">
                <div class="modal-header" style="background: linear-gradient(135deg, #1e3a5f, #2563eb);">
                  <div class="d-flex align-items-center">
                    <div class="header-icon-wrap mr-3" style="width:36px;height:36px;">
                      <i class="fe fe-message-circle" style="font-size:16px;color:#fff;"></i>
                    </div>
                    <span class="h6 mb-0 font-weight-bold text-white" id="slideRightModalLabel">Facility Reviews</span>
                  </div>
                  <button type="button" class="close text-white ml-auto" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body p-3">
                  <div class="mb-3" v-if="summary">
                    <p class="font-weight-bold text-dark mb-1" style="font-size:.85rem;">
                      <i class="fe fe-cpu mr-1 text-primary"></i> AI Summary
                    </p>
                    <p class="text-secondary small">{{ summary }}</p>
                  </div>

                  <div v-for="comment in comments" :key="comment" class="mb-3 p-3"
                    style="background:#f8f9fa;border-radius:8px;border-left:3px solid #2563eb;">
                    <div class="d-flex align-items-start justify-content-between mb-1">
                      <p class="mb-0" style="font-size:.88rem;">{{ comment.body }}</p>
                      <div class="ml-2 flex-shrink-0">
                        <span v-if="comment.sentiment == 'Neutral'" class="status-badge status-badge--vetted" style="font-size:.7rem;">Neutral</span>
                        <span v-if="comment.sentiment == 'Positive'" class="status-badge status-badge--approved" style="font-size:.7rem;">Positive</span>
                        <span v-if="comment.sentiment == 'Negative'" class="status-badge status-badge--rejected" style="font-size:.7rem;">Negative</span>
                      </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                      <small class="text-muted">
                        {{ comment.created_at | moment("from", "now") }}
                        <span v-if="comment.user">&middot; {{ comment.user.firstname }} {{ comment.user.lastname }}</span>
                      </small>
                      <div class="d-flex align-items-center" style="gap:6px;">
                        <star-rating v-if="comment.health_record && comment.health_record.rating"
                          star-size="12" :rating="comment.health_record.rating.score"
                          :show-rating="false" read-only="true" active-color="#198754" />
                        <a v-if="comment.health_record" class="btn btn-sm btn-outline-secondary py-0 px-2"
                          target="_blank" :href="`/encounter/${comment.health_record.id}`">
                          <i class="mdi mdi-medical-bag"></i>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div v-if="!comments || comments.length === 0" class="text-center text-muted py-4">
                    <i class="fe fe-message-circle" style="font-size:2rem;display:block;margin-bottom:8px;"></i>
                    No reviews yet
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-sm btn-outline-secondary" data-dismiss="modal">Close</button>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="vld-parent">
          <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  import FacilityAnalytics from "@/views/analytics/components/FacilityAnalytics.vue";
  import SpecializationsCard from "@/views/telemedicine/SpecializationsCard.vue";
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin
  import StarRating from "vue-star-rating";
  let agency = JSON.parse(localStorage.getItem("agency"));

  export default {
    components: { FacilityAnalytics,
      Navbar,
      Loading,
      StarRating,
      SpecializationsCard,
    },
    data() {
      return {
      canSeeAnalytics: (function () { const u = JSON.parse(localStorage.getItem("user") || "{}") || {}; return ["shis", "employee", "provider", "provider_employee"].includes(u.type); })(),
        user: null,
        comments: "",
        singleprovider: "",
        providerclients: [],
        providers: [],
        selectedEnrolleeIds: [],
        selectAllEnrollees: false,
        targetProviderId: "",
        isMoving: false,
        summary: "",
        dashboarddata: "",
        edit: false,
        isLoading: false,
        fullPage: true,
        agency_id: "",
        selectedHMO: "",
        page: 1,
        pageSize: 100,
      };
    },
    computed: {

      pagedProviderclients() {
        const start = (this.page - 1) * this.pageSize;
        return this.filteredProviderclients.slice(start, start + this.pageSize);
      },

      filteredProviderclients() {
        if (!this.selectedHMO) {
          return this.providerclients;
        }
        return this.providerclients.filter((client) => {
          return client.tpa && String(client.tpa.id) === String(this.selectedHMO);
        });
      },
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/detailedProviderHmo/${this.$route.params.id}`)
        .then((response) => {
          this.singleprovider = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    methods: {
      dynamicClass() {
        return {
          active: this.isActive,
          disabled: this.isDisabled,
          highlighted: this.isHighlighted,
        };
      },
      getData() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/provider-dashboard-data/${this.$route.params.id}`)
          .then((response) => {
            this.dashboarddata = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getProvider() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/detailedProviderHmo/${this.$route.params.id}`)
          .then((response) => {
            this.singleprovider = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getProviderClients() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/getProviderToUser/${this.$route.params.id}`, {
            params: {
              org_id: this.org_id
            }
          })
          .then((response) => {
            this.providerclients = response.data || [];
            this.page = 1;
            const allIds = this.providerclients.map((enrollee) => enrollee.id);
            this.selectedEnrolleeIds = this.selectedEnrolleeIds.filter((id) =>
              allIds.includes(id)
            );
            this.syncSelectAllState();
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getProviders() {
        this.axios
          .get(`/api/v1/auth/providerAgency/${agency.id}`)
          .then((response) => {
            const allProviders = response.data.data || [];
            this.providers = allProviders.filter(
              (provider) => String(provider.id) !== String(this.$route.params.id)
            );
          })
          .catch((error) => {
            console.error(error);
          });
      },

      toggleSelectAllEnrollees() {
        if (this.selectAllEnrollees) {
          this.selectedEnrolleeIds = this.filteredProviderclients.map((enrollee) => enrollee.id);
          return;
        }
        this.selectedEnrolleeIds = [];
      },

      syncSelectAllState() {
        this.selectAllEnrollees =
          this.filteredProviderclients.length > 0 &&
          this.selectedEnrolleeIds.length === this.filteredProviderclients.length;
      },

      async moveSelectedEnrollees() {
        if (!this.targetProviderId) {
          this.$toasted.error("Please select a new provider", {
            position: "top-center",
            duration: 3000,
          });
          return;
        }

        if (String(this.targetProviderId) === String(this.$route.params.id)) {
          this.$toasted.error("Please select a different provider", {
            position: "top-center",
            duration: 3000,
          });
          return;
        }

        if (this.selectedEnrolleeIds.length === 0) {
          this.$toasted.error("Please select at least one enrollee", {
            position: "top-center",
            duration: 3000,
          });
          return;
        }

        if (!confirm(`Move ${this.selectedEnrolleeIds.length} enrollee(s) to selected provider?`)) {
          return;
        }

        this.isMoving = true;

        let successCount = 0;
        let failedCount = 0;
        const selectedIds = [...this.selectedEnrolleeIds];

        for (const enrolleeId of selectedIds) {
          try {
            const requestResponse = await this.axios.post("/api/v1/auth/change_providers", {
              client_id: enrolleeId,
              prepared_by: this.user.id,
              agency_id: agency.id,
              new_health_facility: Number(this.targetProviderId),
              previous_health_facility: Number(this.$route.params.id),
              status: "created",
              reason_for_change: "Moved by agency from provider dashboard",
            });

            const requestId =
              (requestResponse.data && requestResponse.data.id) ||
              (requestResponse.data && requestResponse.data.data && requestResponse.data.data.id);

            if (requestId) {
              await this.axios.post(`/api/v1/auth/change_providers/update/${requestId}`, {
                status: "approved",
              });
            }

            successCount += 1;
          } catch (error) {
            console.error(error);
            failedCount += 1;
          }
        }

        this.isMoving = false;

        if (successCount > 0) {
          this.$toasted.success(`${successCount} enrollee(s) moved successfully`, {
            position: "top-center",
            duration: 3000,
          });
          this.selectedEnrolleeIds = [];
          this.selectAllEnrollees = false;
          this.getProviderClients();
          this.getData();
        }

        if (failedCount > 0) {
          this.$toasted.error(`${failedCount} enrollee(s) failed to move`, {
            position: "top-center",
            duration: 3000,
          });
        }
      },

      getComments() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/comments`, {
            params: {
              paginate_value: 30,
              provider_id: this.$route.params.id,
            },
          })
          .then((response) => {
            this.comments = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getAIComments() {
        this.axios
          .post(`https://api-aicomments.hayokmedicare.ng/analyze_sentiments`, {
            comments: this.comments,
          })
          .then((response) => {
            this.comments = response.data.comments;
            this.summary = response.data.summary;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      acceptProvider(status) {
        if (confirm("Are You Sure You Want to Update Provider?")) {
          this.user = JSON.parse(localStorage.getItem("user"));
          this.isLoading = true;
          this.axios
            .post("/api/v1/auth/approveDisapproveProviderByAgency", {
              agency_id: agency.id,
              provider_id: this.$route.params.id,
              status: status,
            })
            .then((response) => {
              console.log(response);
              this.$breadstick.notify("Provider Updated!", {
                position: "top-right",
              });
              this.isLoading = false;
              this.getProvider();
            })
            .catch((error) => {
              console.log(error.response);
              this.isLoading = false;
            });
        }
      },
      rejectProvider() {
        if (confirm("Are You Sure You Want to Disapprove this Provider?")) {
          this.user = JSON.parse(localStorage.getItem("user"));
          this.isLoading = true;
          this.axios
            .post("/api/v1/auth/approveDisapproveProviderByAgency", {
              agency_id: this.user.id,
              provider_id: this.$route.params.id,
              status: 0,
            })
            .then((response) => {
              console.log(response);
              this.$breadstick.notify("Provider Disapproved!", {
                position: "top-right",
              });
              this.isLoading = false;
              this.getProvider();
            })
            .catch((error) => {
              console.log(error.response);
              this.isLoading = false;
            });
        }
      },
      clearIt() {
        this.agency_id = "";
      },
      editUser(enrollee) {
        this.isLoading = true;
        this.axios
          .patch(`/api/v1/auth/id-card-number/change/${enrollee.id}`)
          .then((response) => {
            console.log(response);
            this.$toasted.success("Changed Successfully", {
              position: "top-center",
              duration: 3000,
            });
            this.isLoading = false;
          })
          .catch((error) => {
            console.error(error);
            this.$toasted.error("Error!", {
              position: "top-center",
              duration: 3000,
            });
            this.isLoading = false;
          });
      },

      deleteUser() {
        if (confirm("Are you Sure you want to delete this Provider")) {
          this.axios
            .delete(`/api/v1/auth/deleteUser/${this.$route.params.id}`)
            .then((response) => {
              console.log(response);
              this.$toasted.success("Deleted Successfully", {
                position: "top-center",
                duration: 3000,
              });
              this.$router.push(`/my-providers`);
            })
            .catch((error) => {
              console.error(error);
            });
        }
      },

      changeNumber(enrollee) {
        this.axios
          .patch(
            `/api/v1/auth/id-card-number/change/${enrollee.id}`,
            {
              type: "client",
            }
          )
          .then((response) => {
            console.log(response);
            this.$toasted.success("ID Updated Successfully", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            console.error(error);
            this.$toasted.error("Not Found!", {
              position: "top-center",
              duration: 3000,
            });
            this.isLoading = false;
          });
      },

      getTPAs() {
        this.user = JSON.parse(localStorage.getItem("user"));

        this.axios
          .get(`/api/v1/auth/org_agency/${agency.id}`)
          .then((response) => {
            this.tpas = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },

    },
    created() {
      this.getProvider();
      this.getProviderClients();
      this.getProviders();
      this.getData();
      this.getComments();
      this.getTPAs();
    },
  };
</script>
